import React, {useEffect, useState} from 'react';
import {Card, Container, Dropdown, Header, Icon, Image, Label, Menu, Segment} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";
import {fetchCourseCategories, fetchCourses} from "../../redux/actions";
import {useHistory} from "react-router";

const CourseCard = ({category, course}) => {

    const history = useHistory();

    const link = `?category=${category}&course_id=${course.id}`;
    const cover = course.cover ? course.path + course.cover : false;
    let installments = 'GRATUITO';
    if (!course.free) {
        const price = (course.price / course.installments).toFixed(2);
        installments = `${course.installments}x de ${price}`
    }

    return (
        <Card
            onClick={() => history.push(link)}
        >
            <Image
                src={cover || 'https://img-a.udemycdn.com/course/240x135/1586752_2d9e_2.jpg'}
                wrapped
                ui={false}
            />

            {
                course.free ? <Label color={"green"} style={{position: "absolute", left: 6, top: 8, padding: 14}}>
                    <Icon name='dollar sign'/>CURSO GRÁTIS
                </Label> : null
            }

            {
                course.discount ? <Label color={"red"} style={{position: "absolute", left: 6, top: 8, padding: 14}}>
                    <Icon name='tag'/>EM PROMOÇÃO
                </Label> : null
            }

            <Card.Content>
                <Header size={"small"}>{course.name}</Header>
                {/*<Card.Meta>*/}
                {/*    <span className='date'>{moment(course.created_at).format('DD/MM/YYYY HH:mm')}</span>*/}
                {/*</Card.Meta>*/}
                {/*<Card.Description content={course.description}/>*/}
            </Card.Content>
            <Card.Content extra className={'course-extra'}>
                <div style={{color: '#525252'}}>{course.free ? null : `R$ ${course.price.toFixed(2)}`}</div>
                <div style={{fontSize: 14}}>{installments}</div>
            </Card.Content>
        </Card>
    )
}
const orders = [
    {
        key: 'asc_name',
        value: 'asc_name',
        text: 'Por nome',
    }, {
        key: 'desc_created_at',
        value: 'desc_created_at',
        text: 'Recentes',
    }, {
        key: 'asc_price',
        value: 'asc_price',
        text: 'Menor preço',
    }, {
        key: 'desc_price',
        value: 'desc_price',
        text: 'Maior preço',
    }
];

const filters = [
    {
        key: 'all',
        value: 'all',
        text: 'Todos',
    },
    {
        key: 'free',
        value: 'free',
        text: 'Gratuitos',
    },
    {
        key: 'pay',
        value: 'pay',
        text: 'Pagos',
    },
    {
        key: 'discount',
        value: 'discount',
        text: 'Em promoção',
    }
];

export const Courses = ({category, place, product}) => {
    const [loading, setLoading] = useState(false)
    const [params, setParams] = useState({place_id: undefined})
    const [filter, setFilter] = useState('all')
    const [order, setOrder] = useState('asc_name')
    const [categories, setCategories] = useState([])
    const [courseCategory, setCourseCategory] = useState(undefined)
    const [courses, setCourses] = useState([])

    const label = product ? 'Produtos' : 'Cursos';

    const fetchData = async () => {
        let config = {...params};

        if (!config.place_id) {
            return;
        }

        setLoading(true);

        try {

            config['active'] = 1;
            config['product'] = product;

            if (filter === 'free') {
                config['free'] = 1;
            } else if (filter === 'pay') {
                config['free'] = 0;
            } else if (filter === 'discount') {
                config['discount'] = 1;
            }

            let direction = order.indexOf('_');

            config['direction'] = order.substr(0, direction);
            config['sort'] = order.substr((direction+1), order.length);

            if(courseCategory){
                config['course_category_id'] = courseCategory;
            }

            // get posts
            const result = await fetchCourses(config);

            // set posts
            setCourses(result.data);

        } catch (e) {
            // show errors
            console.log('error', e);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        if (!place.id) {
            return;
        }

        setParams({place_id: place.id});
    }, [place]);

    useEffect(() => {
        // noinspection JSIgnoredPromiseFromCall
        fetchData();
    }, [params, courseCategory, order, filter]);

    useEffect(() => {
        async function getData() {
            try {
                const res = await fetchCourseCategories({place_id: place.id, active: 1, product: 1});
                const options = res.data
                    .map(function (row) {
                        return {
                            key: row.id,
                            text: row.name,
                            value: row.id,
                        };
                    });
                setCategories(options);
            } catch (e) {
                console.log(e);
            }
        }

        // noinspection JSIgnoredPromiseFromCall
        getData();
    }, [place]);

    if(!courseCategory && courses.length === 0){
        return <React.Fragment/>
    }

    return (
        <Container as="section" id={"courses"} className="section-courses">
            <Header as="h2" className="mb-0">
                <FormattedMessage id={label}/>
            </Header>
            <Container className="details-courses">
                <Menu stackable secondary style={{marginBottom: 0}}>
                    <Menu.Menu position='right'>
                        <Menu.Item>
                            <span style={{paddingRight: 8}}><strong>Categorias:</strong></span> {' '} <Dropdown
                            selection
                            clearable
                            options={categories}
                            value={courseCategory}
                            onChange={(e, {value}) => setCourseCategory(value)}
                        />
                        </Menu.Item>
                        <Menu.Item>
                            <span style={{paddingRight: 8}}><strong>Ordenar:</strong></span> {' '} <Dropdown
                            selection
                            options={orders}
                            value={order}
                            onChange={(e, {value}) => setOrder(value)}
                        />
                        </Menu.Item>

                        <Menu.Item>
                            <span style={{paddingRight: 8}}><strong>Exibir:</strong></span> {' '} <Dropdown
                            selection
                            options={filters}
                            value={filter}
                            onChange={(e, {value}) => setFilter(value)}
                        />
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
                <Segment basic loading={loading} style={{marginTop: 0}}>
                    <Card.Group stackable itemsPerRow={4}>
                        {
                            courses.map((course) => <CourseCard
                                    key={`course-${course.id}`}
                                    category={category}
                                    course={course}
                            />)
                        }
                    </Card.Group>
                </Segment>
            </Container>
        </Container>
    );
};